export const QRCodeExpired = 'qrCodeExpired';
export const SessionClosed = 'sessionClosed';
export const RestaurantClosed = 'restaurantClosed';
